<div class="row">
  <div class="col col-12">
    <app-header />
  </div>
</div>

<div tuiCardLarge tuiSurface="elevated">
  <div class="row">
    <div class="col col-12">
      <div class="row">
        <div class="col col-12">
          <div tuiHeader>
            <h1>Médecins</h1>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col col-12">
          <div class="row">
            <div class="col col-9">
              <form [formGroup]="searchForm" (ngSubmit)="onSubmitForm()">
                <div class="row">
                  <div class="col col-8">
                    <tui-input formControlName="nom">
                      Rechercher par nom
                      <input tuiTextfieldLegacy />
                    </tui-input>
                  </div>
                  <div class="col col-4">
                    <tui-select formControlName="role">
                      Filtrer par rôle
                      <input tuiTextfieldLegacy />
                      <tui-data-list-wrapper *tuiDataList [items]="roleList" />
                    </tui-select>
                  </div>
                  <button size="m" tuiButton style="display: none">OK</button>
                </div>
              </form>
            </div>
            @if (
              authService.getUser()?.role?.slug == "super-admin" ||
              authService.getUser()?.role?.slug == "admin"
            ) {
              <div class="col col-3">
                <tui-loader
                  class="loader"
                  [showLoader]="syncronisationEnCours()"
                >
                  <button
                    (click)="synchronisationDesUtilisateurs()"
                    tuiButton
                    [disabled]="syncronisationEnCours()"
                  >
                    Synchronisation des utilisateurs
                  </button>
                </tui-loader>
              </div>
            }
          </div>
          <div class="row">
            <div class="col col-12">
              <app-medecin-list [nom]="nom0()" [role]="role0()" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
